import Result from "@/core/common/Result";

export interface ICadastrarVoucherGatewayParams {
  email: string;
  telefone: string;
  voucherId: string;
}

export interface ICadastrarVoucherGateway {
  cadastrar(params: ICadastrarVoucherGatewayParams): Promise<Result<void>>;
}

export const cadastrarVoucherGatewayDI = "cadastrarVoucherGatewayDI";
